import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  dismiss() {
    this.element.classList.add("dismissible--closing");

    setTimeout(() => {
      this.element.remove();
    }, 300);
  }
}
